import React, { useEffect } from 'react'
import { cloneDeep } from 'lodash'
import axios from 'axios'
import { InsightContentSettingType } from 'components/insightContent/types'
import { createDocumentSearch } from 'utils/runSearchUtil'
import { useAppDispatch } from 'app/hooks'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { SortByOptions } from 'enums'
import { Post } from 'schemas/PostSchema'
import { ERROR_MESSAGE } from 'features/insightContent/insightContentSlice'

const createSearch = (detailSetting: InsightContentSettingType, post: Post) => {
  const { topicId, filter, precision } = detailSetting

  const clonedFilter = cloneDeep(filter)
  clonedFilter.includedPosts = [[post]]

  return createDocumentSearch(
    -1,
    '',
    [topicId],
    clonedFilter,
    precision,
    SortByOptions.TIME,
    1,
    true,
    true
  )
}

const RunSearchEffect = ({
  detailSetting,
  post,
  children
}: {
  detailSetting: InsightContentSettingType
  post: Post
  children: React.ReactNode
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const search = createSearch(detailSetting, post)

    // eslint-disable-next-line prefer-destructuring
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.PHOTO_CONCEPT_MEDIA,
        searches: [search],
        timestamp: refreshTimestamp,
        requestConfig: {
          cancelToken: source.token
        }
      })
    )

    return () => {
      // Avoid race condition by cancelling the request when the component is remounted or unmounted.
      source.cancel(ERROR_MESSAGE.REQUEST_CANCELLED)
    }
  }, [dispatch, detailSetting, refreshTimestamp, post])

  return <>{children}</>
}

export default RunSearchEffect
